import axios from "axios";
import Handler from "../dev/map-handler";

import queryString from "query-string";
import url from 'url';

const axiosJson5 = axios.create();

export default class AbstractHandler {

    constructor() {

    }

    /**
     * 
     * @param path 
     * @param param 
     * @returns 
     */
    getRequest = (path: string, param: any) => {
        const qs = queryString.stringify(param);
        const dest = url.resolve(window.location.href, path);
        return axiosJson5.get(dest + '?' + qs).then(response => {
            return Promise.resolve({
                result: "OK",
                response,
            })
        }).catch((error: Error) => {
            console.error(error.stack);
            return Promise.resolve({
                result: "NG",
                error
            });
        });
    }

}